// src/features/executive/account/hooks/use-financial-summary.ts
import { useExecutiveQuery } from 'features/executive/shared/hooks/use-executive-query'
import AccountApi from 'api/executive/account.api'
import type {
  FinancialSummaryResponse,
  GetFinancialSummaryParams,
} from 'api/executive/executive.types'

export function useFinancialSummary() {
  return useExecutiveQuery<GetFinancialSummaryParams, FinancialSummaryResponse>(
    'account.financial-summary',
    AccountApi.getFinancialSummary,
    (f) => {
      if (!f.dateRange?.start || !f.dateRange?.end) return null
      return {
        dateFrom: f.dateRange.start,
        dateTo: f.dateRange.end,
        branchId: f.branchId ?? undefined,
        paymentType: f.paymentType ?? undefined,
      }
    }
  )
}
